import { get, post } from '../Http';

export const getStores = async () => {
    try {
        const queryParams = {
            filters: JSON.stringify({ status: 1 })
        };
        const response = await get(`${process.env.EXTENDED_URL}store`, queryParams);
        return response.data;
    } catch (error) {
        console.error('Error fetching stores:', error);
        throw error;
    }
};

/**
 * Sync Category & Product with PMS
 * @param {string} storeId - Store ID to sync (optional, defaults to localStorage store_id)
 * @returns {Promise} Creation response
 */
export const syncCategoryAndProductWithPms = async (storeId = null) => {
    try {
        const apiData = {
            store_id: storeId || localStorage.getItem('store_id') || "",
        };
        const response = await post(`${process.env.EXTENDED_URL}/pms-sync/run-full-sync`, apiData);
        return response.data;
    } catch (error) {
        console.error('Error syncing category and product with PMS:', error);
        throw error;
    }
};
